export default function getErrors(tab, errors){
  let count = 0, optErrors = errors[tab] || {};

  if(Object.keys(optErrors).length){
    Object.keys(optErrors).map((key)=>{
      let value = optErrors[key];
      if(typeof value !== 'object'){
        count ++;
      }else{
        count += Object.keys(value || {}).length
      }
    })
  }

  return count;
}
